import { render, staticRenderFns } from "./UnitMeasure.vue?vue&type=template&id=61cd7318&"
import script from "./UnitMeasure.vue?vue&type=script&lang=js&"
export * from "./UnitMeasure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports